(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').factory('AgendamentoService',AgendamentoService);

  function AgendamentoService($http, ngsalConfig) {

    var service = {
      realizarAgendamento: realizarAgendamento,
      listarAgendamentosCorrente: listarAgendamentosCorrente,
      excluirAgendamento: excluirAgendamento
    };

    return service;

    function realizarAgendamento(periodoSelecionado) {

      var promise = $http.post(`/mgp-corregedoria/api/${ngsalConfig.apiVersion}/relatorio/eleitoral/agendamento/${periodoSelecionado}`)
      .then( (response) => {
        return response.data;
      });

      return promise;
    }

    function listarAgendamentosCorrente() {
      var promise = $http.get(`/mgp-corregedoria/api/${ngsalConfig.apiVersion}/relatorio/eleitoral/agendamento`)
      .then( (response) => {
        return response.data;
      });

      return promise;
    }

    function excluirAgendamento(idAgendamento){

      var promise = $http.delete(`/mgp-corregedoria/api/${ngsalConfig.apiVersion}/relatorio/eleitoral/agendamento/${idAgendamento}`)
      .then( (response) => {
        return response.data;
      });

      return promise;
    }
  }

})();
